"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _UserGroupRestrictionsList = _interopRequireDefault(require("./UserGroupRestrictionsList"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var UserGroupRestrictions = function UserGroupRestrictions(_ref) {
  var settings = _ref.settings,
      setSettings = _ref.setSettings;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "customer-group-restriction-section"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "mt-2"
  }, "User Group Restrictions"), /*#__PURE__*/_react["default"].createElement(_UserGroupRestrictionsList["default"], {
    settings: settings,
    setSettings: setSettings
  }));
};

var _default = UserGroupRestrictions;
exports["default"] = _default;